export const hostsSettings = {
  apiPage:
    window.location.host === "localhost:3000"
      ? "http://localhost:3001/api"
      : `https://${window.location.host.split(".")[0]}.digitalkassir.ru/api`,
};

export const units = [
  {
    name: "Шт.",
    id: 0,
  },
  {
    name: "Грамм",
    id: 10,
  },
  {
    name: "Килограмм",
    id: 11,
  },
  {
    name: "Тонна",
    id: 12,
  },
  {
    name: "Сантиметр",
    id: 20,
  },
  {
    name: "Дециметр",
    id: 21,
  },
  {
    name: "Метр",
    id: 22,
  },
  {
    name: "Квадратный сантиметр",
    id: 30,
  },
  {
    name: "Квадратный дециметр",
    id: 31,
  },
  {
    name: "Квадратный метр",
    id: 32,
  },
  {
    name: "Миллилитр",
    id: 40,
  },
  {
    name: "Литр",
    id: 41,
  },
  {
    name: "Кубический метр",
    id: 42,
  },
  {
    name: "Киловатт час",
    id: 50,
  },
  {
    name: "Гигакалория",
    id: 51,
  },
  {
    name: "Сутки (день)",
    id: 70,
  },
  {
    name: "Час",
    id: 71,
  },
  {
    name: "Минута",
    id: 72,
  },
  {
    name: "Секунда",
    id: 73,
  },
  {
    name: "Килобайт",
    id: 80,
  },
  {
    name: "Мегабайт",
    id: 81,
  },
  {
    name: "Гигабайт",
    id: 82,
  },
  {
    name: "Терабайт",
    id: 83,
  },
  {
    name: "Другое",
    id: 255,
  },
];

export const payment_subjects = [
  {
    name: "Товар",
    id: 1,
  },
  {
    name: "Подакцизный товар",
    id: 2,
  },
  {
    name: "Работа",
    id: 3,
  },
  {
    name: "Услуга",
    id: 4,
  },
  {
    name: "Ставка азартной игры",
    id: 5,
  },
  {
    name: "Выигрыш азартной игры",
    id: 6,
  },
  {
    name: "Лотерейный билет",
    id: 7,
  },
  {
    name: "Выигрыш лотереи",
    id: 8,
  },
  {
    name: "Предоставление РИД",
    id: 9,
  },
  {
    name: "Платеж",
    id: 10,
  },
  {
    name: "Агентское вознаграждение",
    id: 11,
  },
  {
    name: "Составной предмет расчета",
    id: 12,
  },
  {
    name: "Иной предмет расчета",
    id: 13,
  },
  {
    name: "Имущественное право",
    id: 14,
  },
  {
    name: "Внереализационный доход",
    id: 15,
  },
  {
    name: "Страховые взносы",
    id: 16,
  },
  {
    name: "Торговый сбор",
    id: 17,
  },
  {
    name: "Курортный сбор",
    id: 18,
  },
  {
    name: "Залог",
    id: 19,
  },
  {
    name: "Расход",
    id: 20,
  },
  {
    name: "Взносы на ОПС ИП",
    id: 21,
  },
  {
    name: "Взносы на ОПС",
    id: 22,
  },
  {
    name: "Взносы на ОМС ИП",
    id: 23,
  },
  {
    name: "Взносы на ОМС",
    id: 24,
  },
  {
    name: "Взносы на ОСС",
    id: 25,
  },
  {
    name: "Платеж казино",
    id: 26,
  },
  {
    name: "Выдача ДС",
    id: 27,
  },
  {
    name: "Акцизный товар не маркированный",
    id: 30,
  },
  {
    name: "Акцизный товар маркированный",
    id: 31,
  },
  {
    name: "Товар не маркированный",
    id: 32,
  },
  {
    name: "Товар маркированный",
    id: 33,
  },
];

export const vats = [
  {
    name: "НДС 20%",
    id: 1,
  },
  {
    name: "НДС 10%",
    id: 2,
  },
  {
    name: "НДС расч. 20/120",
    id: 3,
  },
  {
    name: "НДС расч. 10/110",
    id: 4,
  },
  {
    name: "НДС 0%",
    id: 5,
  },
  {
    name: "НДС не облагается",
    id: 6,
  },
  {
    name: "НДС 5%",
    id: 7,
  },
  {
    name: "НДС 7%",
    id: 8,
  },
  {
    name: "НДС расч. 5/105",
    id: 9,
  },
  {
    name: "НДС расч. 7/107",
    id: 10,
  },
  {
    name: "Ставка НДС 22% (c 01.01.2026)",
    id: 11,
  },
  {
    name: "Ставка НДС расч. 22/122 (c 01.01.2026)",
    id: 12,
  },
];

export const formPayments = [
  {
    name: "Наличный расчет",
    id: 0,
  },
  {
    name: "Безналичный расчёт",
    id: 1,
  },
];

export const paymentTypes = [
  {
    name: "Предоплата 100%",
    id: 1,
  },
  {
    name: "Предоплата",
    id: 2,
  },
  {
    name: "Аванс",
    id: 3,
  },
  {
    name: "Полный расчет",
    id: 4,
  },
  {
    name: "Частичный расчет и кредит",
    id: 5,
  },
  {
    name: "Передача в кредит",
    id: 6,
  },
  {
    name: "Оплата кредита",
    id: 7,
  },
];

export const calculationSigns = [
  {
    name: "Приход",
    id: 1,
  },
  {
    name: "Возврат прихода",
    id: 2,
  },
  {
    name: "Расход",
    id: 3,
  },
  {
    name: "Возврат расхода",
    id: 4,
  },
];

export const taxations = [
  {
    name: "ОСН",
    id: 1,
  },
  {
    name: "УСН доход",
    id: 2,
  },
  {
    name: "УСН доход - расход",
    id: 4,
  },
  {
    name: "ЕСН",
    id: 16,
  },
  {
    name: "ПСН",
    id: 32,
  },
];

export const timezones = [
  {
    name: "МСК-1, Московское время минус 1 час, UTC+2",
    id: 1,
  },
  {
    name: "МСК, Московское время, UTC+3",
    id: 2,
  },
  {
    name: "МСК+1, Московское время плюс 1 час, UTC+4",
    id: 3,
  },
  {
    name: "МСК+2, Московское время плюс 2 часа, UTC+5",
    id: 4,
  },
  {
    name: "МСК+3, Московское время плюс 3 часа, UTC+6",
    id: 5,
  },
  {
    name: "МСК+4, Московское время плюс 4 часа, UTC+7",
    id: 6,
  },
  {
    name: "МСК+5, Московское время плюс 5 часов, UTC+8",
    id: 7,
  },
  {
    name: "МСК+6, Московское время плюс 6 часов, UTC+9",
    id: 8,
  },
  {
    name: "МСК+7, Московское время плюс 7 часов, UTC+10",
    id: 9,
  },
  {
    name: "МСК+8, Московское время плюс 8 часов, UTC+11",
    id: 10,
  },
  {
    name: "МСК+9, Московское время плюс 9 часов, UTC+12",
    id: 11,
  },
];

export const is_internet = [
  {
    name: "не используется для расчетов в сети «Интернет»",
    id: 0,
  },
  {
    name: "ККТ используется для расчетов в сети «Интернет»",
    id: 1,
  },
];
